import React from 'react';
import { connect } from 'react-redux';

import TravellerButton from '../TravellerButton/TravellerButton';
import TravellerSelection from '../TravellerSelection/TravellerSelection';
import TravellerOuter from '../TravellerOuter/TravellerOuter';
import TravellerInner from '../TravellerInner/TravellerInner';
import TravellerCount from '../TravellerCount/TravellerCount';

import * as travellersActions from '../../../store/actions/index';

const travellers = (props) => {

    return (
        <TravellerOuter>
            <p className="u-textColorLight mb-2">Travellers</p>
            <div className={`u-borderRadius6 u-borderTraveller u-overflowHidden`}>
                <TravellerInner>
                    <TravellerButton 
                        onClick={() => {
                            props.onResetSlideCounter();
                            props.onClickAdult();
                        }}
                        isactive={props.adultActive.toString()}
                        >Adult { props.adult > 0 ? <TravellerCount>{props.adult}</TravellerCount> : null }
                        </TravellerButton>
                    <TravellerButton 
                        onClick={() => {
                            props.onResetSlideCounter();
                            props.onClickChild();
                        }} 
                        isactive={props.childActive.toString()}
                        >Child { props.child > 0 ? <TravellerCount>{props.child}</TravellerCount> : null }</TravellerButton>
                    <TravellerButton 
                        onClick={() => {
                            props.onResetSlideCounter();
                            props.onClickInfant();
                        }} 
                        isactive={props.infantActive.toString()}
                        >Infant { props.infant > 0 ? <TravellerCount>{props.infant}</TravellerCount> : null }</TravellerButton>
                </TravellerInner>
                <div className={`pl-3 pr-4 pt-3 pb-2`}>
                    <TravellerSelection 
                        clicked={(event) => {
                            if(parseInt(event.target.value, 10) + parseInt(props.child, 10) > 9) return;
                            props.onSetAdult(event.target.value)
                        }} 
                        active={props.adultActive}
                        number={props.adult}
                        type='adult'
                        lob='flight'
                        />
                    <TravellerSelection 
                        clicked={(event) => {
                            if(parseInt(event.target.value, 10) + parseInt(props.adult, 10) > 9) return;
                            props.onSetChild(event.target.value)
                        }} 
                        active={props.childActive}
                        number={props.child}
                        type='child'
                        lob='flight'
                        />
                    <TravellerSelection 
                        clicked={(event) => {
                            if(parseInt(event.target.value, 10) > parseInt(props.adult, 10)) return;
                            props.onSetInfant(event.target.value)
                        }} 
                        active={props.infantActive}
                        number={props.infant}
                        type='infant'
                        lob='flight'
                        />
                </div>
            </div>
        </TravellerOuter> 
    );
} 

const mapStateToProps = state => {
    return {
        adultActive: state.travellers.adultActive,
        childActive: state.travellers.childActive,
        infantActive: state.travellers.infantActive
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetAdult: (value) => dispatch(travellersActions.setAdult(value)),
        onSetChild: (value) => dispatch(travellersActions.setChild(value)),
        onSetInfant: (value) => dispatch(travellersActions.setInfant(value)),
        onClickAdult: () => dispatch(travellersActions.clickFlightAdult()),
        onClickChild: () => dispatch(travellersActions.clickFlightChild()),
        onClickInfant: () => dispatch(travellersActions.clickFlightInfant()),
        onResetSlideCounter: () => dispatch(travellersActions.resetSlideCounter())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(travellers);


// WEBPACK FOOTER //
// ./src/components/Travellers/FlightTravellers/FlightTravellers.js